import { DateTime } from "luxon";

export const convertToLocalTimeZone = (dateTime: string): DateTime => {
  // Always assuming UTC input data
  return DateTime.fromISO(dateTime, { zone: "utc" }).toLocal();
};

export const fromNow = (dateTime: string): string | null => {
  return convertToLocalTimeZone(dateTime).toRelative();
};

export const convertDateToLocalTime = (dateTime: string): string => {
  return convertToLocalTimeZone(dateTime).toFormat("yyyy-MM-dd h:mma");
};

export const convertDateToLocalDate = (dateTime: string): string => {
  return convertToLocalTimeZone(dateTime).toFormat("yyyy-MM-dd");
};

export const convertDateToLocalTimeString = (dateTime: string): string => {
  return convertToLocalTimeZone(dateTime).toFormat("MMM dd, yyyy hh:mm a");
};

export const formatDateForData = (dateTime: string): string => {
  return convertToLocalTimeZone(dateTime).toFormat("yyyy-MM-dd");
};

export const formatDateToStandard = (dateTime: string): string => {
  return convertToLocalTimeZone(dateTime).toFormat("M/d/yyyy");
};

export const convertDateToLocalDateWithExpiration = (
  dateTime: string,
): { finalDate: string; daysDiff: number } => {
  const convertedDateTime = convertToLocalTimeZone(dateTime);
  const finalDate = convertedDateTime.toFormat("M/d/yyyy");
  const daysDiff = DateTime.now().diff(convertedDateTime, "days").days;
  return {
    finalDate,
    daysDiff,
  };
};
